<script setup lang="ts">
import { Home, Scroll, User } from "lucide-vue-next";
import { ref } from "vue";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";

// select active tab based on current route
import { RouterLink } from "vue-router";
import { useRoute } from "vue-router";

const route = useRoute();
const activeTab = ref((route.fullPath as string) || "home");
</script>

<template>
  <Tabs
    v-model="activeTab"
    class="fixed bottom-0 left-0 right-0 bg-background border-t z-50"
  >
    <TabsList class="flex w-full h-14 rounded-none">
      <RouterLink to="/" class="grow">
        <TabsTrigger
          value="/"
          class="flex flex-col items-center justify-center gap-1 h-full w-full cursor-pointer"
        >
          <Home class="h-4 w-4" />
          <span class="text-xs">Home</span>
        </TabsTrigger>
      </RouterLink>
      <RouterLink to="/profile" class="grow">
        <TabsTrigger
          value="/profile"
          class="flex flex-col items-center justify-center gap-1 h-full w-full cursor-pointer"
        >
          <User class="h-4 w-4" />
          <span class="text-xs">Profile</span>
        </TabsTrigger>
      </RouterLink>

      <RouterLink to="/lan-info" class="grow">
        <TabsTrigger
          value="/lan-info"
          class="flex flex-col items-center justify-center gap-1 h-full w-full cursor-pointer"
        >
          <Scroll class="h-4 w-4" />
          <span class="text-xs">Bookings</span>
        </TabsTrigger>
      </RouterLink>
    </TabsList>
  </Tabs>
</template>
